import { render, staticRenderFns } from "./userStatisticsChannel.vue?vue&type=template&id=77d789d9&scoped=true&"
import script from "./userStatisticsChannel.vue?vue&type=script&lang=js&"
export * from "./userStatisticsChannel.vue?vue&type=script&lang=js&"
import style0 from "./userStatisticsChannel.vue?vue&type=style&index=0&id=77d789d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d789d9",
  null
  
)

export default component.exports